/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Storefront_Hasnt_Been_SeInputs */

const en_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This storefront hasn't been set up yet. If you're the seller,`)
};

const es_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta tienda aún no ha sido configurada. Si eres el vendedor,`)
};

const fr_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette vitrine n'a pas encore été configurée. Si vous êtes le vendeur,`)
};

const de_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Storefront wurde noch nicht eingerichtet. Wenn du der Verkäufer bist,`)
};

const ja_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このストアフロントはまだ設定されていません。あなたが出品者の場合は、`)
};

const zh_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此店铺尚未进行设置。如果您是卖家，请`)
};

const ar_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم إعداد واجهة المتجر هذه بعد. إذا كنت البائع،`)
};

const id_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase ini belum disiapkan. Jika Anda penjualnya,`)
};

const it_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa vetrina non è stata ancora configurata. Se sei il venditore,`)
};

const ru_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта витрина еще не была настроена. Если вы продавец,`)
};

const pt_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta vitrine ainda não foi configurada. Se você for o vendedor,`)
};

const ko_this_storefront_hasnt_been_se = /** @type {(inputs: This_Storefront_Hasnt_Been_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 스토어프론트는 아직 설정되지 않았습니다. 만약 판매자이시라면,`)
};

/**
* | output |
* | --- |
* | "This storefront hasn't been set up yet. If you're the seller," |
*
* @param {This_Storefront_Hasnt_Been_SeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const this_storefront_hasnt_been_se = /** @type {((inputs?: This_Storefront_Hasnt_Been_SeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Storefront_Hasnt_Been_SeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_storefront_hasnt_been_se(inputs)
	if (locale === "es") return es_this_storefront_hasnt_been_se(inputs)
	if (locale === "fr") return fr_this_storefront_hasnt_been_se(inputs)
	if (locale === "de") return de_this_storefront_hasnt_been_se(inputs)
	if (locale === "ja") return ja_this_storefront_hasnt_been_se(inputs)
	if (locale === "zh") return zh_this_storefront_hasnt_been_se(inputs)
	if (locale === "ar") return ar_this_storefront_hasnt_been_se(inputs)
	if (locale === "id") return id_this_storefront_hasnt_been_se(inputs)
	if (locale === "it") return it_this_storefront_hasnt_been_se(inputs)
	if (locale === "ru") return ru_this_storefront_hasnt_been_se(inputs)
	if (locale === "pt") return pt_this_storefront_hasnt_been_se(inputs)
	return ko_this_storefront_hasnt_been_se(inputs)
});